export default __webpack_public_path__ + "static/np-5efb6dbf3c8b4deeca0e157a4b68570b.svg";